export const QueueReportType = Object.freeze({
  RlvManagementReport: 5,
  SAEE10Report: 14,
})
